//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { PropertyModel } from './PropertyModel';
  import { DataLinkModel } from './DataLinkModel';
  import { DynamicRuleProfileModel } from './DynamicRuleProfileModel';
  
  export class DynamicEntityModel extends ModelBase {
      static readonly $typeName = 'DynamicEntityModel';
      public key: string;
      public isActive: boolean;
      public dataSetKey: string;
      public description: string;
      public name: string;
      public properties: PropertyModel[];
      public dataLinks: DataLinkModel[];
      public businessRules: DynamicRuleProfileModel[];
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DynamicEntityModel.ts